module.exports = __webpack_public_path__ + "assets/8638b706b5f530a91405a0efa1c4eb04.svg";